import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, MapPin, Users, Music, BookOpen, Heart } from 'lucide-react';

// --- FUNÇÕES DE CÁLCULO DE DATA ---

// Função genérica para validar e avançar mês se necessário
function calcularProximaData(funcaoRegra) {
  const hoje = new Date();
  // Zera as horas de hoje para comparar apenas o dia (evita bugs se o evento for hoje)
  const hojeSemHora = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());

  let mes = hoje.getMonth() + 1;
  let ano = hoje.getFullYear();

  // 1. Tenta calcular a data para o mês atual
  let dataEvento = funcaoRegra(mes, ano);

  // 2. Se a data retornada for nula ou já tiver passado (anterior a hoje), calcula para o próximo mês
  if (!dataEvento || dataEvento < hojeSemHora) {
    mes++;
    // Virada de ano (Dezembro -> Janeiro)
    if (mes > 12) {
      mes = 1;
      ano++;
    }
    dataEvento = funcaoRegra(mes, ano);
  }

  return dataEvento;
}

// Regra: 3º Sábado
function regraTerceiroSabado(mes, ano) {
  let count = 0;
  // Loop seguro do dia 1 ao 31
  for (let dia = 1; dia <= 31; dia++) {
    const data = new Date(ano, mes - 1, dia, 19, 0, 0); // Define horário do evento (19h)
    if (data.getMonth() !== mes - 1) break; // Sai se o mês mudou (ex: dia 31 em mês de 30)
    
    if (data.getDay() === 6) { // 6 = Sábado
      count++;
      if (count === 3) return data;
    }
  }
  return null;
}

// Regra: 1ª Sexta
function regraPrimeiraSexta(mes, ano) {
  for (let dia = 1; dia <= 7; dia++) {
    const data = new Date(ano, mes - 1, dia, 19, 30, 0); // Horário 19:30
    if (data.getDay() === 5) return data; // 5 = Sexta
  }
  return null;
}

// Regra: Última Sexta
function regraUltimaSexta(mes, ano) {
  let ultima = null;
  for (let dia = 1; dia <= 31; dia++) {
    const data = new Date(ano, mes - 1, dia, 19, 30, 0); // Horário 19:30
    if (data.getMonth() !== mes - 1) break;
    if (data.getDay() === 5) ultima = data;
  }
  return ultima;
}

// --- CÁLCULO FINAL DAS DATAS ---
// Isso garante que se o 3º sábado de Dezembro já passou, ele mostre o de Janeiro
const dataJovens = calcularProximaData(regraTerceiroSabado);
const dataHomens = calcularProximaData(regraPrimeiraSexta);
const dataMulheres = calcularProximaData(regraUltimaSexta);

const Agenda = () => {
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const eventos = [
    {
      id: 1,
      titulo: 'Culto de Celebração da Família',
      categoria: 'culto',
      data: '', // Recorrente semanal
      diaSemana: 'Domingo',
      horario: '19:00',
      
      descricao: 'Nosso principal culto semanal com toda a família MEVAM. Momento especial de adoração, Palavra e comunhão.',
     
      icon: Users,
      cor: 'bg-gradient-to-r from-[#030B2E] to-[#17E6B3]/80'
    },
    {
      id: 2,
      titulo: 'Culto Profético',
      categoria: 'culto',
      diaSemana: 'Quinta-feira',
      horario: '20:00',
      
      descricao: 'Momento especial de busca e renovação espiritual. Venha receber uma palavra profética para sua vida!',
      
      icon: Heart,
      cor: 'bg-gradient-to-br from-[#17E6B3] to-[#030B2E]'
    },
    {
      id: 3,
      titulo: 'PG Familiar / MEVAM Academy',
      categoria: 'discipulado',
      diaSemana: 'Terça-feira',
      horario: '19:30',
      
      descricao: 'Pequenos Grupos Familiares e MEVAM Academy. Crescimento espiritual e discipulado em grupos menores.',
      icon: BookOpen,
      cor: 'bg-gradient-to-r from-[#17E6B3]/90 to-[#030B2E]'
    },

    // EVENTOS COM DATAS DINÂMICAS
    {
      id: 4,
      titulo: 'Rede de Jovens',
      categoria: 'especial',
      // Se dataJovens existir, usa ela, senão deixa vazio
      data: dataJovens ? dataJovens.toISOString() : '', 
      diaSemana: 'Terceiro Sábado do Mês',
      horario: '19:30',
     
      descricao: 'Encontro dinâmico e cheio de vida para os jovens da igreja e seus convidados, com louvor, pregação e comunhão.',
     
      icon: Music,
      cor: 'bg-gradient-to-bl from-[#17E6B3] to-[#030B2E]/90'
    },
    {
      id: 5,
      titulo: 'Rede de Homens',
      categoria: 'especial',
      data: dataHomens ? dataHomens.toISOString() : '',
      diaSemana: 'Primeira Sexta do Mês',
      horario: '19:30',
            descricao: 'Encontro especial para homens. Tempo de comunhão, palavra e crescimento para líderes, pais e filhos.',
      
      icon: Users,
      cor: 'bg-gradient-to-tr from-[#030B2E] to-[#17E6B3]/70'
    },
    {
      id: 6,
      titulo: 'Rede de Mulheres',
      categoria: 'especial',
      data: dataMulheres ? dataMulheres.toISOString() : '',
      diaSemana: 'Última Sexta do Mês',
      horario: '19:30',
            descricao: 'Encontro especial para mulheres. Tempo de comunhão, palavra, oração e fortalecimento para todas as idades.',
     
      icon: Heart,
      cor: 'bg-gradient-to-tl from-[#17E6B3]/80 to-[#030B2E]'
    },
    {
      id: 7,
      titulo: 'Reunião de Oração',
      categoria: 'oracao',
      diaSemana: 'Quinta-feira',
      horario: '08:00',
      
      descricao: 'Momento especial de oração matinal. Comece seu dia buscando a presença de Deus e intercedendo pela igreja.',
      
      icon: Heart,
      cor: 'bg-gradient-to-r from-[#030B2E]/95 to-[#17E6B3]'
    },
  ];

  const categorias = [
    { id: 'todos', nome: 'Todos os Eventos' },
    { id: 'culto', nome: 'Cultos' },
    { id: 'especial', nome: 'Eventos Especiais' },
    { id: 'discipulado', nome: 'Discipulado' },
    { id: 'oracao', nome: 'Oração' }
  ];

  const eventosFiltrados = selectedCategory === 'todos' 
    ? eventos 
    : eventos.filter(evento => evento.categoria === selectedCategory);

  const formatarData = (dataString) => {
    if(!dataString) return '';
    const data = new Date(dataString);
    // Ajuste de fuso horário simples (mantendo o dia correto)
    const dia = data.getDate();
    const mes = data.toLocaleDateString('pt-BR', { month: 'long' });
    const ano = data.getFullYear();
    
    // Capitalizar primeira letra do mês
    const mesFormatado = mes.charAt(0).toUpperCase() + mes.slice(1);
    
    return `${dia} de ${mesFormatado} de ${ano}`;
  };

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-br from-[#030B2E] via-[#030B2E] to-[#17E6B3]/20 text-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Nossa Agenda
            </h1>
            <p className="text-xl md:text-2xl text-[#B8C4E3]">
              Participe dos nossos cultos e atividades. Toda a família é bem-vinda!
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filtros */}
      <section className="py-8 bg-[#030B2E] border-b border-[#17E6B3]/20">
        <div className="container-custom">
          <div className="flex flex-wrap justify-center gap-4">
            {categorias.map((categoria) => (
              <motion.button
                key={categoria.id}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setSelectedCategory(categoria.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                  selectedCategory === categoria.id
                    ? 'bg-[#17E6B3] text-[#030B2E] shadow-lg shadow-[#17E6B3]/30'
                    : 'bg-white/10 text-[#B8C4E3] hover:bg-white/20 border border-[#17E6B3]/30'
                }`}
              >
                {categoria.nome}
              </motion.button>
            ))}
          </div>
        </div>
      </section>

      {/* Grade de Eventos */}
      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {selectedCategory === 'todos' ? 'Todos os Eventos' : categorias.find(c => c.id === selectedCategory)?.nome}
            </h2>
            <p className="text-[#B8C4E3] text-lg">
              Confira nossa programação completa e não perca nenhum momento especial
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {eventosFiltrados.map((evento, index) => {
              const IconComponent = evento.icon;
              return (
                <motion.div
                  key={evento.id}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white/5 backdrop-blur-sm rounded-xl overflow-hidden hover:shadow-2xl hover:shadow-[#17E6B3]/20 transition-all duration-300 border border-[#17E6B3]/20 flex flex-col h-full"
                >
                  {/* Header colorido */}
                  <div className={`${evento.cor} p-4 text-white relative overflow-hidden`}>
                    <div className="absolute top-0 right-0 opacity-20">
                      <IconComponent size={80} />
                    </div>
                    <div className="relative z-10">
                      <h3 className="text-xl font-bold mb-2">{evento.titulo}</h3>
                      <p className="text-sm opacity-90">{evento.diaSemana}</p>
                    </div>
                  </div>

                  {/* Conteúdo */}
                  <div className="p-6 bg-white flex-grow flex flex-col">
                    <div className="space-y-4 mb-6">
                      <div className="flex items-center text-[#030B2E]">
                        <Clock className="mr-3 text-[#17E6B3] flex-shrink-0" size={20} />
                        <span className="font-semibold">{evento.horario}</span>
                      </div>
                      {/* Local removido */}
                      {evento.palestrante && (
                        <div className="flex items-center text-[#030B2E]">
                          <Users className="mr-3 text-[#17E6B3] flex-shrink-0" size={20} />
                          <span className="font-semibold">{evento.palestrante}</span>
                        </div>
                      )}
                    </div>

                    <p className="text-gray-700 mt-auto">{evento.descricao}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Informações Importantes (Mantido igual ao original, omitindo para brevidade mas você deve manter o restante do código abaixo) */}
       {/* ... resto do seu código (seção de horários de culto e footer) ... */}
    </div>
  );
};

export default Agenda;